import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Button from 'components/modules/button/Button';
import Modal from 'components/modules/modal/Modal';
import { RoomInfoItems } from 'constant';
import { IStoreState } from 'store/modules';

interface ModalMemoProps {
  roomId?: string;
  info: any;
  onClose: (
    isRegister: boolean,
    dLoc: string,
    wCond: string,
    accType: string,
    dType: string,
    dRoute: string,
    loc: string,
    dtl: string
  ) => void;
}

interface IRooomInfo {
  dLoc: string;
  wCond: string;
  accType: string;
  dType: string;
  dRoute: string;
  accLoc: string;
  accDtl: string;
}

const ModalInfo = ({ roomId, info, onClose }: ModalMemoProps) => {
  const vessels = useSelector((store: IStoreState) => store.MainReducer.vessels);
  const [isShow, setShow] = useState(false);
  const title = roomId === undefined ? '해양사고 등록' : '해양사고 수정';
  const [roomInfo, setRoomInfo] = useState<IRooomInfo>({
    dLoc: '',
    wCond: '',
    accType: '',
    dType: '',
    dRoute: '',
    accLoc: '',
    accDtl: '',
  });

  const onChangeDtl = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.currentTarget.value;
    if (value.length <= 100) {
      setRoomInfo({
        ...roomInfo,
        accDtl: value,
      });
    }
  };

  const onChangeSelect = (key: string, e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setRoomInfo((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const _Close = (isRegister: boolean) => {
    setShow(false);
    onClose(
      isRegister,
      roomInfo.dLoc,
      roomInfo.wCond,
      roomInfo.accType,
      roomInfo.dType,
      roomInfo.dRoute,
      roomInfo.accLoc,
      roomInfo.accDtl
    );
  };

  const onSave = async () => {
    try {
      _Close(true);
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    if (info !== undefined) {
      setShow(info.isOpen);

      let accDtlValue = info.dtl;
      if (roomId === undefined) {
        const targetVessel = vessels.find((v) => v.mdn === info.mdn);
        if (targetVessel !== undefined) {
          accDtlValue = targetVessel.bbn;
        }
      }

      setRoomInfo((prev) => ({
        ...prev,
        dLoc: info.dLoc,
        wCond: info.wCond,
        accType: info.accType,
        dType: info.dType,
        dRoute: info.dRoute,
        accLoc: info.loc,
        accDtl: accDtlValue,
      }));
    }
  }, [info]);

  return (
    <Modal isOpen={isShow} onClose={() => _Close(false)}>
      <ModalTemplate>
        <HeaderWrap>
          <HeaderTitle>{title}</HeaderTitle>
        </HeaderWrap>

        <RegisterWrapp>
          <Grid>
            {RoomInfoItems.map((item: any, index: number) => (
              <div style={{ display: 'flex' }} key={index}>
                <SelectTitle>{item.title}</SelectTitle>
                <SelectWrap id={item.id} value={roomInfo[item.id]} onChange={(e) => onChangeSelect(item.id, e)}>
                  {item.options.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </SelectWrap>
              </div>
            ))}
          </Grid>
        </RegisterWrapp>

        <ContentsWrap>
          <DtlWrap>
            <SubTitleWrap>사고내용</SubTitleWrap>
            <DtlTextArea
              placeholder="사고내용을 입력하세요(최대 100자)"
              rows={5}
              value={roomInfo.accDtl}
              onChange={onChangeDtl}
              maxLength={100}
            />
          </DtlWrap>
        </ContentsWrap>

        <FooterWrap>
          <Button title="취소" color="secondary" onClick={() => _Close(false)} />
          <Button title={roomId === undefined ? '등록' : '수정'} onClick={onSave} />
        </FooterWrap>
      </ModalTemplate>
    </Modal>
  );
};

const ModalTemplate = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100%);
  // height: calc(100% - 140px);
  flex-flow: column nowrap;
  background-color: #abc9df;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
`;
const HeaderWrap = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background-color: #11497e;
  // border-bottom: 2px solid #cccccc;
  border-radius: 10px 10px 0 0;
`;
const HeaderTitle = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  // justify-content: center;
  margin-left: 20px;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
`;
const RegisterWrapp = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 30px 0;
  border-radius: 10px;
`;
const ContentsWrap = styled.div`
  padding: 0 10px;
  display: flex;
  flex-flow: column nowrap;
  @media (max-width: 319px) {
    padding: 0 10px;
  }
`;
const DtlWrap = styled.div`
  position: relative;
  padding: 0 15px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: baseline;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
`;
const SubTitleWrap = styled.div`
  position: relative;
  padding-right: 10px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
`;
const DtlTextArea = styled.textarea`
  flex: 0 0 auto;
  border-radius: 10px;
  padding: 12px;
  width: 75%;
  min-width: 250px;
  min-height: 100px;
  background-color: #f2f2f2;
  border: 2px solid #dddddd;
  font-size: 16px;
  font-weight: 600;
  resize: none;

  ::placeholder {
    text-align: center;
    color: #000000;
    position: absolute;
    // top: calc(50% - 10px);
    // left: 0;
    // right: 0;
    // bottom: 0;
    line-height: 20px;
  }
`;
const FooterWrap = styled.div`
  padding: 20px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 5px;
    border-radius: 10px;
    min-height: 40px;
    max-width: 140px;
    cursor: pointer;
  }
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px 3px;
`;
const SelectTitle = styled.div`
  display: flex;
  width: 100px;
  height: 44px;
  align-items: center;
  justify-content: center;
  background: #11497e;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  flex-shrink: 0;
  border-top-left-radius: 5px;
  // border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  // border-bottom-right-radius: 5px;
`;
const SelectWrap = styled.select`
  width: 100%;
  height: 44px;
  border: none;
  font-size: 16px;
  background: #f7fafd;
  padding-left: 12px;
  flex-grow: 1;
  border-top-right-radius: 5px;
  // border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`;

export default ModalInfo;
